<template>
  <v-flex class="">
    <h2 class="text-center py-4 my-6 mb-2"
        :class="[{'text-h2': !$vuetify.breakpoint.mobile, 'text-h3': $vuetify.breakpoint.mobile}]"
        data-aos="fade-down"
    >
        {{header}}
    </h2>
    <v-row no-gutters>
      <v-col cols="12"
      :data-aos="$vuetify.breakpoint.mobile ? 'fade-up' : 'fade-right'"
      class="d-flex justify-end pa-4 col-sm-6">
        <v-sheet elevation="18" height="fit-content">
          <v-carousel v-if="carousel" hide-delimiters :show-arrows="false"  continous cycle  interval="3000" height="auto">
            <v-carousel-item v-for="(item, i) in getCarouselPath" :key="i" >
              <v-img :src="item" :max-width="getMaxWidth" max-height="300"/>
            </v-carousel-item>
          </v-carousel>
          <v-img :src="getImagePath" :max-width="getMaxWidth" max-height="450" v-else/>
        </v-sheet>
      </v-col>
      <v-col cols="12"
      :data-aos="$vuetify.breakpoint.mobile ? 'fade-up' : 'fade-left'"
      class="pa-4 col-sm-6">
        <slot name="content"></slot>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script>
  export default {
    name: 'AppearContentScroll',
    props: [
      'image',
      'header',
      'carousel',
      'twist'
    ],
    computed: {
      getImagePath() {
        return require(`@/assets/${this.image}`);
      },
      getCarouselPath() {
        return this.carousel.map(e => require(`@/assets/${e}`));
      },
      getMaxWidth() {
        return this.$vuetify.breakpoint.name === 'xs' ? 'auto' : 500;
      }
    }
  }
</script>

<style lang="css">

</style>
